import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDatenCheckLogsApi } from './aktienApi';

/**
 * Redux-Slice fuer den Debug-Bereich der Uebersichtsseite: Daten-Check-Logs
 * (History-Differenzen und Kursspruenge), die die Abruf-Scheduler schreiben.
 */
export const fetchDebugLogs = createAsyncThunk(
  'debugLogs/fetchAlle',
  async (limit = 200) => {
    return (await fetchDatenCheckLogsApi(limit)) ?? [];
  }
);

const initialState = {
  liste: [],
  status: 'idle', // idle | loading | succeeded | failed
  error: null,
};

const debugLogsSlice = createSlice({
  name: 'debugLogs',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDebugLogs.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchDebugLogs.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.liste = action.payload;
      })
      .addCase(fetchDebugLogs.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const selectDebugLogs = (state) => state.debugLogs.liste;
export const selectDebugLogsStatus = (state) => state.debugLogs.status;

export default debugLogsSlice.reducer;
